export default __webpack_public_path__ + "static/media/boar_gray.992933f7.svg";